export default "__VITE_ASSET__D6Vzo2Tk__";